import React from "react";
import { motion } from "framer-motion";
import { EXPERIENCE, EDUCATION } from "../lib/data";

export const Experience = () => {
  return (
    <section id="experience" data-testid="experience-section" className="py-24 md:py-32 bg-secondary/40 border-t border-black/5">
      <div className="max-w-6xl mx-auto px-6">
        <p className="overline text-primary mb-4">Experience</p>
        <h2 className="font-serif text-3xl md:text-5xl text-foreground mb-16 max-w-2xl leading-tight">
          Nine years across enterprise, product, and design consultancy.
        </h2>

        <div className="space-y-4">
          {EXPERIENCE.map((exp, i) => (
            <motion.div
              key={exp.company}
              data-testid="experience-card"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="group grid md:grid-cols-12 gap-6 rounded-2xl border border-black/5 bg-white p-6 md:p-8 card-shadow hover:-translate-y-1 transition-transform duration-300"
            >
              <div className="md:col-span-4">
                <div className="font-mono text-xs text-primary tracking-widest">{exp.period}</div>
                <h3 className="font-serif text-2xl text-foreground mt-2">{exp.company}</h3>
                <div className="text-sm text-foreground/60 mt-1">{exp.title}</div>
                <div className="text-xs text-foreground/40 mt-1">{exp.location}</div>
              </div>
              <ul className="md:col-span-8 space-y-3">
                {exp.points.map((pt, idx) => (
                  <li key={idx} className="flex gap-3 text-foreground/70 leading-relaxed">
                    <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary/60" />
                    <span>{pt}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        <div className="mt-16">
          <p className="overline text-primary mb-6">Education</p>
          <div className="grid sm:grid-cols-2 gap-4">
            {EDUCATION.map((ed) => (
              <div key={ed.school} data-testid="education-card" className="rounded-2xl border border-black/5 bg-white p-6">
                <div className="font-mono text-xs text-primary tracking-widest">{ed.period}</div>
                <h4 className="font-serif text-xl text-foreground mt-2">{ed.school}</h4>
                <div className="text-sm text-foreground/60 mt-1">{ed.degree}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
